module.exports = __webpack_public_path__ + "static/media/salah.a648fb8f.jpg";